/**
 * Moves the product page's info blocks into left/right side columns on
 * desktop (>=990px), around the sticky image gallery. Below that width
 * nothing runs: the blocks stay exactly where the server rendered them, in
 * plain mobile reading order (title, price, variant picker, stock, add to
 * cart, shipping — then description/accordions/share).
 *
 * This has to happen in JS rather than pure CSS because the desktop layout
 * (two independently-stacking columns) and the mobile reading order
 * (buy box before the description) are two different orderings of the same
 * blocks — no combination of flexbox/grid `order` can produce both from a
 * single DOM order without one side inflating the other's spacing.
 */
(function () {
  var DESKTOP_QUERY = '(min-width: 990px)';

  function layoutProduct(root) {
    var leftSlot = root.querySelector('[data-product-slot="left"]');
    var rightSlot = root.querySelector('[data-product-slot="right"]');
    var marker = root.querySelector('[data-product-end-marker]');
    if (!leftSlot || !rightSlot || !marker) return;

    var blocks = Array.prototype.slice.call(root.querySelectorAll('[data-product-zone]'));
    if (!blocks.length) return;

    var isDesktop = window.matchMedia(DESKTOP_QUERY).matches;

    if (isDesktop) {
      blocks.forEach(function (el) {
        var zone = el.getAttribute('data-product-zone');
        (zone === 'right' ? rightSlot : leftSlot).appendChild(el);
      });
      leftSlot.hidden = false;
      rightSlot.hidden = false;
    } else {
      blocks.sort(function (a, b) {
        return Number(a.getAttribute('data-product-order')) - Number(b.getAttribute('data-product-order'));
      });
      blocks.forEach(function (el) {
        root.insertBefore(el, marker);
      });
      leftSlot.hidden = true;
      rightSlot.hidden = true;
    }
  }

  function layoutAll() {
    document.querySelectorAll('[data-product-3col]').forEach(layoutProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', layoutAll);
  } else {
    layoutAll();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(layoutAll, 150);
  });
})();
